import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/HomeView.vue')
  },
  {
    path: '/carStage',
    name: 'carStage',
    component: () => import('@/views/CarStage.vue')
  },
  {
    path: '/carStageDetail',
    name: 'carStageDetail',
    component: () => import('@/views/CarStageDetail.vue')
  },
  {
    path: '/matterApply',
    name: 'matterApply',
    component: () => import('@/views/MatterApply.vue')
  },
  {
    path: '/matterHandle',
    name: 'matterHandle',
    component: () => import('@/views/MatterHandle.vue')
  },
  {
    path: '/matterList',
    name: 'matterList',
    component: () => import('@/views/MatterList.vue')
  },
  {
    path: '/carMarket',
    name: 'carMarket',
    component: () => import('@/views/CarMarket.vue')
  },
  {
    path: '/tradeMatter',
    name: 'tradeMatter',
    component: () => import('@/views/TradeMatter.vue')
  },
  {
    path: '/tradeMatterDetail',
    name: 'tradeMatterDetail',
    component: () => import('@/views/TradeMatterDetail.vue')
  }
]

const router = new VueRouter({
  routes
})

export default router
